
import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as Eyeoff } from '../../assets/eye-off.svg';
import { useState } from 'react';

function LoginCredentialsForm({
  username, setUsername,
  password, setPassword,
  loading, onSubmit
}) {

    const [showPassword, setShowPassword] = useState(false);
  
  return (
    <form onSubmit={onSubmit}>
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
          Username
        </label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter your username"
          required
          disabled={loading}
        />
      </div>

      <div style={{ marginBottom: '24px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
          Password
        </label>

        <div style={{
          position: 'relative',
          marginBottom: '12px'
        }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
            disabled={loading}
            style={{
              width: '100%',
              boxSizing: 'border-box'
            }}
          />
        <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center'
            }}
            disabled={loading}
          >
            {showPassword ? (
              <Eye size={20} color="#666" />
            ) : (
              <Eyeoff size={20} color="#666" />
            )}
          </button>
          </div>
      </div>

      <button
        type="submit"
        disabled={loading}
        style={{
          width: '100%',
          padding: '14px',
          background: loading ? '#aaa' : '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          fontSize: '17px',
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? 'Logging in...' : 'Login'}
      </button>
    </form>
  );
}

export default LoginCredentialsForm;